"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATE_SHARE_MODE_RIGHTS = exports.MATE_SHARE_MODES = exports.DEFAULT_MATE_SHARE_MODE = exports.MateShareModeSchema = void 0;
exports.widerMateShareRights = widerMateShareRights;
const zod_1 = require("zod");
/**
 * What a share of a Mate lets a person do through it (epic
 * epc-mates-share-templates, card dec-mst-share-final-1028): one mode. The
 * person's own rights ('intersection') are the ground; the other three,
 * named like the App templates, reach beyond them into what the Mate was
 * invited to.
 */
exports.MateShareModeSchema = zod_1.z.enum([
    'intersection',
    'submit',
    'manageOwn',
    'editAll',
]);
exports.DEFAULT_MATE_SHARE_MODE = 'intersection';
/**
 * The modes a share of each kind of Mate offers. A shared personal Mate acts
 * with its owner's rights and creates no pages for others, so it has no own
 * pages to submit or manage: only own rights or editing all.
 */
exports.MATE_SHARE_MODES = {
    personal: ['intersection', 'editAll'],
    workspace: exports.MateShareModeSchema.options,
};
/** The rights each mode gives; a change never reaches more than reading. */
exports.MATE_SHARE_MODE_RIGHTS = {
    intersection: {
        read: 'intersection',
        create: false,
        update: 'off',
        delete: 'off',
    },
    submit: { read: 'own', create: true, update: 'off', delete: 'off' },
    manageOwn: { read: 'own', create: true, update: 'own', delete: 'own' },
    editAll: {
        read: 'all',
        create: true,
        update: 'likeRead',
        delete: 'likeRead',
    },
};
// The member keeps their own pages (the Mate creates them only where the
// member may create too), so 'own' lies within 'intersection', which lies
// within 'all'.
const READ_WIDTH = {
    own: 0,
    intersection: 1,
    all: 2,
};
const CHANGE_WIDTH = {
    off: 0,
    own: 1,
    likeRead: 2,
};
/** Of two shares reaching the same person, each right counts the wider. */
function widerMateShareRights(known, next) {
    const change = (a, b) => CHANGE_WIDTH[a] >= CHANGE_WIDTH[b] ? a : b;
    return {
        read: READ_WIDTH[known.read] >= READ_WIDTH[next.read] ? known.read : next.read,
        create: known.create || next.create,
        update: change(known.update, next.update),
        delete: change(known.delete, next.delete),
    };
}
